module.exports = __webpack_public_path__ + "static/img/shiziwan3.26dbfbac.png";